import { containsNbsp, nbspToSpace } from './helpers'

const replaceNbspInDataEvent = (evt: CKEDITOR.eventInfo) => {
  const dataValue = evt?.data?.dataValue

  if (typeof dataValue !== 'string' || !containsNbsp(dataValue)) {
    return
  }

  const dataValueDOM = new DOMParser().parseFromString(
    nbspToSpace(dataValue),
    'text/html'
  )

  dataValueDOM.querySelectorAll('span').forEach((el) => {
    const bookmarkEl =
      el.id.startsWith('cke_bm') || el.hasAttribute('data-cke-bookmark')
        ? el
        : null

    if (!bookmarkEl) {
      return
    }

    bookmarkEl.innerHTML = '\u00A0'
  })

  evt.data.dataValue = dataValueDOM.body.innerHTML
}

export const nbspToSpacePlugin: CKEDITOR.pluginDefinition = {
  init: (editor) => {
    editor.on('getData', replaceNbspInDataEvent, null, null, 0)
  },
}
